import 'pobble-components/dist/setup/sentry'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app/app'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer'
import { requestMiddleware } from 'pobble-components/dist/redux-helpers'

import 'normalize.css'
import { apiGetMe } from './common/api/profile'
import { PobbleStyles } from 'pobble-components/dist/styles'

const store = createStore(
  rootReducer,
  applyMiddleware(requestMiddleware, thunk)
)

const render = ({ me, meError }) => {
  ReactDOM.render(
    <Provider store={store}>
      <PobbleStyles>
        <App me={me} meError={meError} />
      </PobbleStyles>
    </Provider>,
    document.getElementById('root')
  )
}

apiGetMe({
  include:
    'account.timestamps,account.names,account.finish_signup_status,account.policy,account.pobbler_type,account.avatar,account.teacher_type.school,account.subscription_policy,account.subscriptions'
}).then(res => render({ me: res }), e => render({ meError: e }))

// Lazy load external tools
setTimeout(() => import('pobble-components/dist/setup/external-tools'), 1000)
